import { Component, Inject } from '@angular/core';
import { RmsModule } from '@rms';
import { CustomerCrmService } from '@services';
import { RmsPulldownRef } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-new-customer-form',
  imports: [RmsModule],
  templateUrl: './new-customer-form.component.html',
  styleUrl: './new-customer-form.component.scss'
})
export class NewCustomerFormComponent {
  Customer: any = { NonDomestic: false };
  Traders: any[] = [];
  PaymentMethods: any[] = [];
  PaymentTerms: any[] = [];

  constructor(
    @Inject(RMS_PULLDOWN_DATA) private data: any,
    public ref: RmsPulldownRef,
    private crm: CustomerCrmService
  ) {
    this.crm.getTraders().subscribe({
      next: (traders: any) => this.Traders = traders || [],
      error: () => this.Traders = []
    });
    this.crm.getPaymentMethods().subscribe({
      next: (methods) => this.PaymentMethods = methods || [],
      error: () => this.PaymentMethods = []
    });
    this.crm.getPaymentTerms().subscribe({
      next: (terms) => this.PaymentTerms = terms || [],
      error: () => this.PaymentTerms = []
    });
  }

  save() {
    this.ref.close({ ...this.Customer, cancelled: false });
  }

  cancel() {
    this.ref.close({ cancelled: true });
  }
}
